import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html'
})
export class SpinnerComponent {
   useCase = 'Block';
  selectedUseCase = 'Block';
  useCases: string[] = [
    'Block', 'Small', 'Medium', 'Large'
  ];
  hasBackgroundColor: boolean = false;
  isBrowser = true as boolean;

  constructor(
    @Inject(PLATFORM_ID) public platformId: any
  ){
    this.isBrowser = isPlatformBrowser(this.platformId)
  }
}